import { render } from "./PaymentViewer.vue?vue&type=template&id=634f8f25&scoped=true"
import script from "./PaymentViewer.vue?vue&type=script&lang=js"
export * from "./PaymentViewer.vue?vue&type=script&lang=js"

import "./PaymentViewer.vue?vue&type=style&index=0&id=634f8f25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634f8f25"]])

export default __exports__